import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';

@Component({ standalone: false,
  selector: 'irb-dialog-pr-resubmit',
  templateUrl: './dialog-pr-resubmit.component.html',
  styleUrls: ['./dialog-pr-resubmit.component.scss','../../irb-common/styles/dialog.scss']
})
export class DialogPrResubmitComponent {
  newRebalanceName: string;
  newTradeExplanation: string = "";
  portfolioName: string = "";

  constructor(
    public dialogRef: MatDialogRef<DialogPrResubmitComponent>,
    public as: AppService,
    @Inject(MAT_DIALOG_DATA) public mdd: any
  ) {
    this.newRebalanceName = this.mdd.data.rebalanceName;
    this.portfolioName = this.mdd.data.portfolioName;
  }

  close() {
    this.dialogRef.close();
  }

  continue() {
    if(this.mdd.onProceed) {
      this.mdd.onProceed({
        newRebalanceName: this.newRebalanceName,
        newTradeExplanation: this.newTradeExplanation
      });
    }

    this.close();
  }
}
